import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, ButtonGroup } from '@material-ui/core';
import { Link } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const AtendimentosToolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  /* Mensagem Erro Geral */
  const [codUserLogado, setUserLogado] = useState({
    codUserLogado : 0

  });

  useEffect(() => {
    setUserLogado();
  });


  const handleSignIn = event => {
    //console.log('clicou..');
    
    //useState codUserLogado =1000;
    //document.getElementById('buttonTodos').disabled = false;
    console.log(codUserLogado);

  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Link to="/atendimento/novo">
          <Button
            active={true}
            color="primary"
            variant="contained"
          >
          Novo
          </Button>
        </Link>
      </div>
      <div>
        <ButtonGroup>
          <Button 
            //active={codUserLogado === sessionStorage.getItem('token')}
            color="primary" 
            active={!(codUserLogado === 0)}
            eu={onhashchange}
            id="buttonLogado"
            //onClick={() => setUserLogado({codUserLogado : sessionStorage.getItem('token')})} 
            onClick={() => setUserLogado({codUserLogado : 0})}             
            
          >Logado</Button>
          <Button 
            color="primary" 
            
            id="buttonTodos"          
//            onClick={() => setUserLogado({codUserLogado : 0})}             
            onClick={() => setUserLogado({codUserLogado : sessionStorage.getItem('token')})} 
            active={(codUserLogado === 0)}                        

            //onClick={handleSignIn()}
          >
            Todos
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

AtendimentosToolbar.propTypes = {
  className: PropTypes.string
};

export default AtendimentosToolbar;
